import React from 'react';
import { Box, boxClasses } from '@rossum/ui/material';
import { useColumnResize } from '../hooks/useColumnResize';
import { COLUMN_RESIZE_HANDLE_WIDTH } from '../utils';

interface ResizeHandleProps {
  columnId: string;
  currentWidth?: number;
  onWidthChange: (width: number) => void;
}

export const ResizeHandle: React.FC<ResizeHandleProps> = ({
  columnId,
  currentWidth,
  onWidthChange,
}) => {
  const { dragProps, isDragging } = useColumnResize({
    columnId,
    currentWidth,
    onWidthChange,
  });
  return (
    <Box
      {...dragProps}
      sx={{
        position: 'absolute',
        top: 0,
        right: 0, // Position on the right border
        bottom: 0,
        width: COLUMN_RESIZE_HANDLE_WIDTH,
        cursor: 'col-resize',
        zIndex: 10,
        maxHeight: '56px',
        [`> .${boxClasses.root}`]: {
          backgroundColor: t =>
            isDragging ? t.palette.primary.main : t.palette.divider,
        },
        '&:hover': {
          [`> .${boxClasses.root}`]: {
            backgroundColor: t =>
              isDragging ? t.palette.primary.main : t.palette.text.primary,
          },
        },
        // Parent hover to show handle
        opacity: 0,
        '.MuiTableRow-root:hover &': {
          opacity: 1,
        },
      }}
    >
      <Box
        sx={{
          width: 2,
          height: 14,
          cursor: 'col-resize',
          position: 'absolute',
          top: '50%',
          right: 0,
          transform: 'translate(0, -50%)',
        }}
      />
    </Box>
  );
};
